import SockJS from "sockjs-client";
import {
  Client,
  Frame,
  IMessage,
  StompSubscription,
} from "@stomp/stompjs";

import moment from "moment";
import store from "../store/store";

import {
  updateBetslipfromWS,
  updateDreamEventOddsWs,
  updateEventOddsfromWS,
  updateFancyMarkets,
  updatePremiumOddsfromWS,
  updateSecondaryMarkets,
} from "../store";

import { setIsConnected } from "../store/exchangeSports/exchangeSportsActions";

let oddsStompClient: Client | null = null;
let dreamOddsStompClient: Client | null = null;

let wsSubscriptions_OddsChanges: Record<string, StompSubscription> = {};
let wsSubscriptions_SrBetStop: Record<string, StompSubscription> = {};
let wsSecMarketSubscritions: Record<string, StompSubscription> = {};

let oddsConnected = false;
let dreamConnected = false;

function createClient(url: string, onConnect: (frame: Frame) => void) {
  return new Client({
    webSocketFactory: () => new SockJS(url),

    reconnectDelay: 5000,

    heartbeatIncoming: 10000,
    heartbeatOutgoing: 10000,

    debug: () => {},

    onConnect: (frame) => {

      onConnect(frame);

    },

    onStompError: (frame) => {
      console.error("STOMP ERROR", frame.headers["message"]);
      console.error(frame.body);
    },

    onWebSocketClose: () => {
      console.log("WebSocket closed");
    },

    onWebSocketError: (event) => {
      console.log("WebSocket Error", event);
    },
  });
}

export const connectToWS = (baseUrlsPayload: any) => {

  if (oddsStompClient?.active) return;

  const baseUrl =
    sessionStorage.getItem("psPartnerId") === "BBPID01"
      ? "https://sr-feed.betbhai.com/odds-feed"
      : sessionStorage.getItem("psProviderId") === "SportRadar" ||
        sessionStorage.getItem("psProviderId") === "GeniusPremium"
      ? baseUrlsPayload?.prBaseUrl
      : "https://feed.mysportsfeed.io/odds-feed";

  oddsStompClient = createClient(baseUrl, (frame) => {

    console.log("Connected", frame.command);
    oddsConnected = true;
    store.dispatch(setIsConnected(true));
  });

  oddsStompClient.activate();
};

export const connectToDreamWS = () => {

  if (dreamOddsStompClient?.active) return;

  dreamOddsStompClient = createClient(
    "https://feed.mysportsfeed.io/odds-feed",
    () => {
      dreamConnected = true;
      console.log("Dream websocket connected");
    }
  );

  dreamOddsStompClient.activate();
};

export const isConnected = () => !!oddsConnected;

export const isDreamWsConnected = () => dreamConnected;

export const subscribeWsForEventOdds = (
  topic: string,
  provider: string,
  eventId: string,
  marketId?: string
) => {

  let topicUrl = `${topic}/${eventId}`;

  if (provider === "Dream") {
    topicUrl = `/topic/dream_match_odds_update/${eventId}/${marketId}`;
  }

  if (!topic || topic.trim() === "") {
    topicUrl = `/topic/sportradar_event_odds_change/${eventId}`;
  }

  if (!oddsConnected || !oddsStompClient) {
    console.warn("WebSocket not connected");
    return;
  }

  if (wsSubscriptions_OddsChanges[eventId]) return;

  if (!oddsStompClient) return;

  wsSubscriptions_OddsChanges[eventId] =
    oddsStompClient.subscribe(topicUrl, (message: IMessage) => {

      const msgObj = JSON.parse(message.body);

      store.dispatch(updateBetslipfromWS(msgObj));

      store.dispatch(updateEventOddsfromWS(msgObj));

      if (
        sessionStorage
          .getItem("lobbyType")
          ?.toLowerCase()
          .includes("premium")
      ) {

        store.dispatch(
          updatePremiumOddsfromWS({
            msgObj,
            type: "odds_update",
          })
        );

      }

    });

};

export const subscribeDreamWsForMatchOdds = (
  provider: string,
  eventId: string,
  marketId?: string
) => {

  let topic = "/topic/betfair_match_odds_update";

  if (provider === "Dream") {
    topic = "/topic/dream_match_odds_update";
  }

  if (!dreamConnected) {
    setTimeout(() => {
      subscribeDreamWsForMatchOdds(provider, eventId, marketId);
    }, 1000);
    return;
  }

  const key = `ws-${eventId}-${marketId}`;

  if (wsSubscriptions_OddsChanges[key]) return;

  wsSubscriptions_OddsChanges[key] =
    dreamOddsStompClient.subscribe(
      `${topic}/${eventId}/${marketId}`,
      (message: IMessage) => {

        store.dispatch(
          updateDreamEventOddsWs(
            JSON.parse(message.body)
          )
        );

      }
    );

};

export const subscribeWsForBookmakerMarkets = (
  eventId: string,
  marketId: string
) => {

  if (!dreamConnected) {
    setTimeout(() => {
      subscribeWsForBookmakerMarkets(eventId, marketId);
    }, 1000);
    return;
  }

  const key = `bm-${eventId}-${marketId}`;

  if (wsSecMarketSubscritions[key]) return;

  wsSecMarketSubscritions[key] =
    dreamOddsStompClient.subscribe(
      `/topic/dream_bookmakers_update/${eventId}/${marketId}`,
      (message: IMessage) => {

        store.dispatch(
          updateSecondaryMarkets(
            JSON.parse(message.body)
          )
        );

      }
    );

};

export const subscribeWsForFancyMarkets = (
  eventId: string
) => {

  if (!dreamConnected) {
    setTimeout(() => {
      subscribeWsForFancyMarkets(eventId);
    }, 1000);
    return;
  }

  const key = `fancy-${eventId}`;

  if (wsSecMarketSubscritions[key]) return;

  wsSecMarketSubscritions[key] =
    dreamOddsStompClient.subscribe(
      `/topic/dream_fancy_odds_update/${eventId}`,
      (message: IMessage) => {

        store.dispatch(
          updateFancyMarkets(
            JSON.parse(message.body)
          )
        );

      }
    );

};

export const subscribeWsForBetStop = (
  provider: string,
  eventId: string
) => {

  if (provider !== "SportRadar") return;

  if (!oddsConnected) {
    setTimeout(() => {
      subscribeWsForBetStop(provider, eventId);
    }, 1000);
    return;
  }

  if (wsSubscriptions_SrBetStop[eventId]) return;

  wsSubscriptions_SrBetStop[eventId] =
    oddsStompClient.subscribe(
      `/topic/sportradar_event_bet_stop/${eventId}`,
      (message: IMessage) => {

        const msgObj = JSON.parse(message.body);

        store.dispatch(updateBetslipfromWS(msgObj));

        store.dispatch(updateEventOddsfromWS(msgObj));

      }
    );

};

export const checkStompClientSubscriptions = (
  baseUrlsPayload: any
) => {

  if (
    !oddsConnected &&
    !store.getState().sportsBook.isSocketConnected
  ) {

    connectToWS(baseUrlsPayload);

  }

};

export const disconnectToWS = async () => {

  unsubscribeAllWsforEvents();

  try {

    if (oddsStompClient?.active) {

      await oddsStompClient.deactivate();

    }

  } catch (e) {

    console.error("Error disconnecting odds websocket", e);

  } finally {

    oddsConnected = false;

    store.dispatch(setIsConnected(false));

    console.log("[WebSocket] Odds websocket disconnected");

  }

  try {

    if (dreamOddsStompClient?.active) {

      await dreamOddsStompClient.deactivate();

    }

  } catch (e) {

    console.error("Error disconnecting dream websocket", e);

  } finally {

    dreamConnected = false;

    console.log("[WebSocket] Dream websocket disconnected");

  }

  oddsStompClient = null;
  dreamOddsStompClient = null;

};

export const unsubscribeAllWsforEvents = () => {

  Object.keys(wsSubscriptions_OddsChanges).forEach((key) => {

    try {

      wsSubscriptions_OddsChanges[key]?.unsubscribe();

      console.log("Unsubscribed:", key);

    } catch (e) {

      console.error(e);

    }

  });

  Object.keys(wsSubscriptions_SrBetStop).forEach((key) => {

    try {

      wsSubscriptions_SrBetStop[key]?.unsubscribe();

      console.log("Unsubscribed:", key);

    } catch (e) {

      console.error(e);

    }

  });

  Object.keys(wsSecMarketSubscritions).forEach((key) => {

    try {

      wsSecMarketSubscritions[key]?.unsubscribe();

      console.log("Unsubscribed:", key);

    } catch (e) {

      console.error(e);

    }

  });

  wsSubscriptions_OddsChanges = {};

  wsSubscriptions_SrBetStop = {};

  wsSecMarketSubscritions = {};

};